import {Modal} from "antd";
import React, {useEffect, useState} from "react";
import {AppstoreOutlined} from "@ant-design/icons";
import FilterButton from "../../piece/FilterButton";
import UsedTypeSelect from "../../piece/UsedTypeSelect";

export default (props) => {
    const [visible, setVisible] = useState(false)
    const [defaultValue, setDefaultValue] = useState(null)
    const [value, setValue] = useState(null)
    useEffect(() => {
        setDefaultValue(props.defaultValue)
    }, [props])

    return (
        <>
            <FilterButton
                onClick={() => {
                    setVisible(true)
                }}
            >
                <AppstoreOutlined/> Business type
            </FilterButton>
            <Modal
                title='Business type Filter'
                visible={visible}
                open={visible}
                onOk={() => {
                    if (props.onChange) {
                        props.onChange({
                            usedTypeFilter: {
                                text: 'Business type',
                                value: value
                            },
                        })
                    }
                    setVisible(false)
                }}
                onCancel={() => {
                    setVisible(false)
                }}
                destroyOnClose={true}
            >
                <UsedTypeSelect
                    placeholder='Please select business type'
                    defaultValue={defaultValue}
                    onChange={setValue}
                />
            </Modal>
        </>
    )
}